import * as types from '../../types/routesReport';

export const startFetchingRoutesReport = (filters = {}) => ({
  type: types.ROUTES_REPORT_FETCH_STARTED,
  payload: filters
});
export const completeFetchingRoutesReport = (
  entities,
  order,
  indicators,
  unitsEntities,
  unitsOrder,
  routesEntities,
  routesOrder
) => ({
  type: types.ROUTES_REPORT_FETCH_COMPLETED,
  payload: {
    entities,
    order,
    indicators,
    unitsEntities,
    unitsOrder,
    routesEntities,
    routesOrder
  }
});
export const failFetchingRoutesReport = (error = { errorMessage: 'Error', errorNumber: 404 }) => ({
  type: types.ROUTES_REPORT_FETCH_FAILED,
  payload: {
    error //error:{errorMessage:'Error', errorNumber:400}
  }
});
